var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpyView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39.844,
  height: 55.891,
  "data-name": "spy view",
  viewBox: "0 0 39.844 55.891"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M9.55 41.154a3 3 0 0 0 0 6h10.916a3 3 0 1 0 0-6Zm12.281 3a1.367 1.367 0 0 1-1.365 1.365H9.55a1.365 1.365 0 0 1 0-2.729h10.916a1.367 1.367 0 0 1 1.367 1.364Z",
  "data-name": "Path 907"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M29.2 8.187a.82.82 0 0 0 .819-.819V.819A.82.82 0 0 0 29.2 0H.819A.82.82 0 0 0 0 .819v54.254a.82.82 0 0 0 .819.819H29.2a.82.82 0 0 0 .819-.819V37.934a.819.819 0 0 0-1.637 0v11.953H1.637V1.637h6V3a3.006 3.006 0 0 0 3 3h8.733a3.006 3.006 0 0 0 3-3V1.637h6v5.731a.82.82 0 0 0 .83.819m-.819 43.338v2.729H1.637v-2.729ZM20.741 3a1.367 1.367 0 0 1-1.365 1.365h-8.733A1.367 1.367 0 0 1 9.279 3V1.637h11.462Z",
  "data-name": "Path 908"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M22.651 15.829a12.87 12.87 0 0 0-11.076 6.823 12.4 12.4 0 0 0 22.151 0 12.87 12.87 0 0 0-11.075-6.823m-.285 10.916a4.094 4.094 0 1 1 .925-8.078.82.82 0 0 1 .614.614 2.47 2.47 0 0 0 1.836 1.836.82.82 0 0 1 .613.614 4.094 4.094 0 0 1-3.988 5.021Z",
  "data-name": "Path 909"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M22.478 20.195h-.109a2.456 2.456 0 1 0 2.456 2.456v-.109a4.13 4.13 0 0 1-2.347-2.347",
  "data-name": "Path 910"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M36.842 9.825H8.458a3.006 3.006 0 0 0-3 3v19.649a3.006 3.006 0 0 0 3 3H36.84a3.006 3.006 0 0 0 3-3V12.825a3.006 3.006 0 0 0-2.998-3m-1.458 13.209a14.074 14.074 0 0 1-25.466 0 .82.82 0 0 1 0-.764 14.074 14.074 0 0 1 25.466 0 .82.82 0 0 1 0 .764",
  "data-name": "Path 911"
})));
export default SvgSpyView;